import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./app"
import { BrowserRouter } from 'react-router-dom';
import './style.css';






const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<div>
<BrowserRouter>
<App/>
</BrowserRouter>
</div>


)




